/** @format */

export const MODAL_SAVE_LATER = 1;
export const MODAL_EDIT = 2;
export const MODAL_UPLOAD_ARTWORK = 3;
export const MODAL_DELETE_ORDER = 4;
export const MODAL_REMOVE_FROM_CART = 5;
export const MODAL_LOGIN = 6;
